import PropTypes from 'prop-types';
import React from 'react';
import {isEmpty as _isEmpty} from 'lodash';

import {withClientBookingsFilters} from '@modules/booking/HOC/withClientBookingsFilters';
import {BookingsFiltersFields} from '@modules/booking/components/BookingsFiltersFields';
import {ContentTypesFilter} from '@utils/commonFilters/ContentTypesFilter';
import {ContentVariantsFilter} from '@utils/commonFilters/ContentVariantsFilter';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {DeviceCategoriesFilter} from '@utils/commonFilters/DeviceCategoriesFilter';
import {DistributionTypesFilter} from '@utils/commonFilters/DistributionTypesFilter';
import {HqFilter} from '@utils/commonFilters/HqFilter';
import {LlFilter} from '@utils/commonFilters/LlFilter';
import {PackagesFilter} from '@utils/commonFilters/PackagesFilter';
import {ProductsFilter} from '@utils/commonFilters/ProductsFilter';
import {BookingStatusFilter} from '@utils/commonFilters/BookingStatusFilter';

const ClientOfferingsFilters = (filtersProps) => {
    const {
        clientFilters,
        loading,
        restoreFilterValues,
        data: {
            products,
            eventContentTypes,
            eventContentVariants,
            distributionTypes,
            deviceCategories,
            countries,
            clientPackages,
        },
    } = filtersProps;

    return (
        <div className='clientOfferings__filters filter__controls__container'>
            <BookingsFiltersFields {...filtersProps} />
            <ContentTypesFilter
                eventContentTypes={eventContentTypes}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <ContentVariantsFilter
                eventContentVariants={eventContentVariants}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <ProductsFilter
                loading={loading}
                products={products}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <DistributionTypesFilter
                distributionTypes={distributionTypes}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <DeviceCategoriesFilter
                deviceCategories={deviceCategories}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <CountriesFilter
                countries={countries}
                loading={_isEmpty(countries)}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <PackagesFilter
                clientPackages={clientPackages}
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <HqFilter
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <LlFilter
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
            <BookingStatusFilter
                loading={loading}
                filters={clientFilters}
                restoreFilterValues={restoreFilterValues}
            />
        </div>
    );
};

ClientOfferingsFilters.propTypes = {
    clientFilters: PropTypes.object,
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func,
    restoreFilterDateValues: PropTypes.func,
    data: PropTypes.shape({
        products: PropTypes.array,
        eventContentTypes: PropTypes.array,
        eventContentVariants: PropTypes.array,
        distributionTypes: PropTypes.array,
        deviceCategories: PropTypes.array,
        countries: PropTypes.array,
        clientPackages: PropTypes.array,
    }),
};

export default withClientBookingsFilters(ClientOfferingsFilters, 'ClientOfferings');

